import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [err, setErr] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setMsg("");
    setBusy(true);
    const r = await register(email, password, name);
    setBusy(false);
    if (r.ok) {
      setMsg(r.message);
      setTimeout(() => nav("/forum"), 1200);
    } else setErr(r.error);
  };

  return (
    <div data-testid="register-page" className="min-h-screen bg-black text-white flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md border border-zinc-800 bg-zinc-950/60 p-8 md:p-10">
        <Link to="/" className="font-mono text-[10px] tracking-[0.3em] text-zinc-500 hover:text-sky-400 uppercase">← Back to home</Link>
        <h1 className="mt-4 font-display text-3xl md:text-4xl uppercase">Register</h1>
        <p className="text-zinc-500 text-sm mt-2">Γινε μελος της κοινοτητας. Ο λογαριασμος σου θα εγκριθει απο admin πριν μπορεσεις να ποσταρεις.</p>

        <form onSubmit={onSubmit} className="mt-8 space-y-4">
          <Field label="Nickname" type="text" value={name} onChange={setName} testid="register-name" min={2} />
          <Field label="Email" type="email" value={email} onChange={setEmail} testid="register-email" />
          <Field label="Password (min 6)" type="password" value={password} onChange={setPassword} testid="register-password" min={6} />
          {err && <div data-testid="register-error" className="text-red-400 text-xs font-mono">{err}</div>}
          {msg && <div data-testid="register-success" className="text-sky-400 text-xs font-mono">{msg}</div>}
          <button
            type="submit"
            disabled={busy}
            data-testid="register-submit"
            className="w-full bg-sky-400 text-black font-bold uppercase tracking-widest py-3 hover:bg-sky-300 transition-colors disabled:opacity-40"
          >
            {busy ? "..." : "Create account"}
          </button>
        </form>
        <div className="mt-6 text-sm text-zinc-500">
          Εχεις ηδη account;{" "}
          <Link to="/login" data-testid="register-to-login" className="text-sky-400 hover:underline">Sign in</Link>
        </div>
      </div>
    </div>
  );
}

function Field({ label, type, value, onChange, testid, min }) {
  return (
    <label className="block">
      <span className="font-mono text-[10px] tracking-[0.3em] text-zinc-500 uppercase">{label}</span>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required
        minLength={min}
        data-testid={testid}
        className="mt-2 w-full bg-black border border-zinc-800 text-white px-4 py-3 focus:outline-none focus:border-sky-400 transition-colors"
      />
    </label>
  );
}
